var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.hasDates && _vm.dayCategories.length)?_c('apexchart',{attrs:{"type":"bar","height":"460","options":_vm.daysOpts,"series":_vm.daysSeries}}):_c('empty-state',{attrs:{"icon":"mdi-calendar-range","title":_vm.$t('no_data'),"subtitle":_vm.$t('select_wider_date_range')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }